<ng-container *transloco="let t; prefix: 'trip-finances.panels.budget-item'">
  <app-panel-body>
    <form class="flex min-h-0 flex-1 flex-col" [formGroup]="form" (ngSubmit)="save()">
      <div class="min-h-0 flex-1 overflow-y-auto">
        <app-content-container>
          <div class="space-y-4">
            <div class="grid grid-cols-1 gap-2 sm:grid-cols-2">
              <ion-item lines="none">
                <ion-select
                  [label]="t('category')"
                  labelPlacement="stacked"
                  formControlName="type"
                  [placeholder]="t('select-category')"
                  interface="popover"
                >
                  @for (opt of budgetTypes; track opt.value) {
                    <ion-select-option [value]="opt.value">{{ t(opt.labelKey) }}</ion-select-option>
                  }
                </ion-select>
              </ion-item>

              <ion-item lines="none">
                <ion-input
                  type="number"
                  [label]="t('amount')"
                  labelPlacement="stacked"
                  formControlName="amount"
                  step="0.01"
                />
              </ion-item>
              @if (form.controls.amount.touched && form.controls.amount.hasError('max')) {
                <app-inline-alert
                  class="col-span-1 sm:col-span-2"
                  severity="danger"
                  [message]="t('amount-max-error')"
                />
              }

              <fieldset class="col-span-1 space-y-2 sm:col-span-2">
                <legend class="mb-1 block text-sm font-medium text-primary-text">{{ t('amount-type') }}</legend>
                <label class="flex items-start gap-2">
                  <input
                    type="radio"
                    formControlName="amountType"
                    [value]="BudgetAmountType.FlatSum"
                  />
                  <span>{{ t('flat-sum-label') }}</span>
                </label>
                <label class="flex items-start gap-2">
                  <input
                    type="radio"
                    formControlName="amountType"
                    [value]="BudgetAmountType.PerPerson"
                  />
                  <span>{{ t('per-person-label') }}</span>
                </label>
              </fieldset>

              <ion-item lines="none" class="col-span-1 sm:col-span-2">
                <ion-input
                  type="text"
                  [label]="t('description')"
                  labelPlacement="stacked"
                  formControlName="description"
                  [maxlength]="500"
                />
              </ion-item>

              <ion-item lines="none" class="col-span-1 sm:col-span-2">
                <ion-input
                  type="date"
                  [label]="t('due-date')"
                  labelPlacement="stacked"
                  formControlName="due"
                />
              </ion-item>
            </div>
          </div>
        </app-content-container>
      </div>

      <div class="flex shrink-0 justify-end gap-3 border-t border-primary-border px-4 py-4">
        <button type="button" class="rounded-md border border-primary-border px-4 py-2 text-sm font-semibold" (click)="cancel()" [disabled]="submitting()">
          {{ t('cancel') }}
        </button>
        <button type="submit" class="btn btn-primary btn-no-grow disabled:opacity-50" [disabled]="submitting() || form.invalid">
          {{ t('save') }}
        </button>
      </div>
    </form>
  </app-panel-body>
</ng-container>
